import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import {
  MessageBoxComponent,
  MessageBoxParameters,
  MessageBoxType,
} from 'app/components/messageBox/messageBox.component';
import { Retention } from 'app/shared/models/retention';
import { Subject } from 'app/shared/models/subject';
import { DataFieldService } from 'app/shared/services/data-field.service';
import { RetentionService } from 'app/shared/services/retention.service';

@Component({
  selector: 'app-retention-prompt',
  templateUrl: './retention-prompt.component.html',
  styleUrls: ['./retention-prompt.component.scss'],
})
export class RetentionPromptComponent implements OnInit {
  listOfRetentions: Retention[];
  form: UntypedFormGroup;
  daysToAdd: number;
  oldRetentionId: number = null;
  oldRetentionDays: number = null;
  retentionAlreadySet: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<RetentionPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private retentionService: RetentionService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    //console.log(this.data.subjectData.data);
    if (this.data)
      this.form = this.fb.group({
        retentionPeriod: [this.data.retentionId, Validators.required],
      });

    this.retentionService.getAllData().subscribe((data) => {
      this.listOfRetentions = data
        .filter((i) => !i.hideRecord)
        .sort((a, b) => a.name.localeCompare(b.name));
    });
    if (this.data.retentionId) {
      this.oldRetentionId = this.data.retentionId;
      this.oldRetentionDays = this.listOfRetentions.filter(
        (i) => i.id === this.oldRetentionId
      )[0].retentionDays;
    }
  }

  // changeRetentionDays(originalDate, periodChange) {
  //   // Create a copy of the date object to avoid modifying the original
  //   const newDate = new Date(originalDate.getTime());
  //   // Add the number of days to the milliseconds since epoch
  //   newDate.setDate(newDate.getDate() + periodChange);
  //   // Return the new date object
  //   return newDate;
  // }

  convertToRetentionDays(daysToAdd, oldDate) {
    let newDate;
    let subject = new Subject(this.data);
    const dateClosed = subject.getDataFieldValue('dateclosed');
    if (oldDate) {
      newDate = new Date(oldDate);
      // Add the number of days to the milliseconds since epoch
    } else {
      newDate = new Date(dateClosed);
    }
    newDate.setDate(newDate.getDate() + daysToAdd);

    const monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = String(newDate.getDate()).padStart(2, '0');
    const monthIndex = newDate.getMonth();
    const month = monthNames[monthIndex];
    const year = newDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  public confirmSubmit() {
    if (this.oldRetentionId != null) {
      const info = new MessageBoxParameters(
        'This will reset the retention date for this case, are you sure?',
        'Confirm',
        MessageBoxType.YesNo,
        true
      );
      this.dialog
        .open(MessageBoxComponent, {
          data: info,
          disableClose: false,
          autoFocus: false,
        })
        .afterClosed()
        .subscribe((result) => {
          if (result === 'yes') {
            this.saveChanges();
          }
        });
    } else this.saveChanges();
  }

  saveChanges() {
    let retention: Retention = this.listOfRetentions.find(
      (i) => i.id == this.form.controls['retentionPeriod'].value
    );
    if (!retention) return;

    this.daysToAdd = retention.retentionDays;
    let retentionDate = '';
    if (this.oldRetentionDays && this.oldRetentionId) {
      this.daysToAdd = this.daysToAdd - this.oldRetentionDays;
      retentionDate = this.convertToRetentionDays(
        this.daysToAdd,
        this.data.retentionDate
      );
    } else {
      retentionDate = this.convertToRetentionDays(this.daysToAdd, null);
    }
    this.data.retentionDate = retentionDate;
    this.data.retentionId = this.listOfRetentions.filter(
      (i) => i.retentionDays === retention.retentionDays
    )[0].id;
    this.dialogRef.close({ data: this.data });
  }
}
